import React from 'react';
import { motion } from 'framer-motion';
import './ServiceDetail.css';

const ServiceDetail = ({ service, onBack }) => {
  if (!service) return null;

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1, delayChildren: 0.2 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { 
      opacity: 1, 
      y: 0, 
      transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] } 
    }
  };

  return (
    <motion.div 
      className="service-detail-page"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
      style={{ '--accent-color': service.color }}
    >
      <div className="detail-bg">
        <div className="detail-blob"></div>
        <div className="detail-grid-overlay"></div>
      </div>

      <div className="detail-container">
        <motion.button 
          className="back-button" 
          onClick={onBack}
          variants={itemVariants}
          whileHover={{ x: -10 }}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
          Back to Services
        </motion.button>

        <section className="detail-hero">
          <div className="hero-content">
            <motion.span className="service-category" variants={itemVariants}>
              Service Expertise
            </motion.span>
            <motion.div className="service-tagline-wrap" variants={itemVariants}>
              <span className="detail-tagline">{service.tagline}</span>
            </motion.div>
            <motion.h1 variants={itemVariants}>
              {service.title.split(' ')[0]} <span>{service.title.split(' ').slice(1).join(' ')}</span>
            </motion.h1>
            <motion.p className="service-desc" variants={itemVariants}>
              {service.description}
            </motion.p>
            <motion.div className="service-tags" variants={itemVariants}>
              {service.features.map((feature, i) => (
                <span key={i} className="tag">{feature}</span>
              ))}
            </motion.div>
          </div>
          
          <motion.div 
            className="hero-visual"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.4 }}
          >
            <div className="visual-orb">
              <div className="orb-image-container">
                <img src={service.image} alt={service.title} className="orb-image" />
              </div>
            </div>
            <div className="visual-glow"></div>
            
            {/* Floating micro-cards for detail */}
            <motion.div 
              className="detail-floating-card top-right"
              animate={{ y: [0, -20, 0] }}
              transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
            >
              <div className="card-dot"></div>
              <span>Premium Performance</span>
            </motion.div>
            
            <motion.div 
              className="detail-floating-card bottom-left"
              animate={{ y: [0, 20, 0] }}
              transition={{ duration: 5, repeat: Infinity, ease: "easeInOut", delay: 0.5 }}
            >
              <div className="card-dot blue"></div>
              <span>Data-Driven Success</span>
            </motion.div>
          </motion.div>
        </section>

        <section className="detail-content">
          <motion.div className="content-grid" variants={itemVariants}>
            <div className="content-box">
              <h3>Our Approach</h3>
              <p>We don't just provide a service; we engineering growth engines. Our approach to {service.title} is built on years of industry data and cutting-edge technological frameworks.</p>
            </div>
            <div className="content-box">
              <h3>Expected Outcomes</h3>
              <ul className="outcomes-list">
                <li>Increased Digital Visibility</li>
                <li>Higer Conversion Ratios</li>
                <li>Long-term Sustained Growth</li>
                <li>Measurable ROI Statistics</li>
              </ul>
            </div>
          </motion.div>
          
          <motion.div className="cta-banner" variants={itemVariants}>
            <h3>Ready to scale your {service.title}?</h3>
            <p>Let's build something extraordinary together.</p>
            <button className="cta-btn">Start Your Project</button>
          </motion.div>
        </section>
      </div>
    </motion.div>
  );
};

export default ServiceDetail;
